export default __webpack_public_path__ + "static/media/img-06.06ff2343.jpg";